import React from 'react'
import { NavItem as ReactstrapNavItem, NavItemProps } from 'reactstrap'

export const NavItem: React.FC<NavItemProps> = props => {
  return <ReactstrapNavItem {...props} />
}
